import { useBoardContext } from '../../../hooks/use-board'
import { CandidateCard } from '../../../candidate/components/candidate-card'
import React from 'react'

export function DropCard() {
    const { activeItem, showAttributes, showPhone } = useBoardContext()

    if (!activeItem?.item) {
        return null
    }

    return (
        <CandidateCard
            active
            className="mb-2 opacity-60"
            candidate={activeItem?.item}
            collapsed={!showAttributes}
            showPhone={showPhone}
        />
    )
}
